// extracted by mini-css-extract-plugin
export default {"Dashboard":"Dashboard_Dashboard__JhvwZ","CardSpinner":"Dashboard_CardSpinner__KIgSz"};